import type { Priority } from "./types";

/**
 * The one place a priority becomes a colour on a bar.
 *
 * The workload strip on the dashboard and the capacity bars both paint
 * segments by priority; sharing the map, rather than a bar component, is what
 * keeps a palette change landing in both without forcing two differently
 * shaped bars through one set of props.
 */
export const PRIORITY_SEGMENT: Record<Priority, string> = {
  0: "bg-error-600",
  1: "bg-error-400",
  2: "bg-warning-400",
  3: "bg-gray-500",
  4: "bg-gray-400",
};

/** Priorities in the order segments and legends show them. */
export const PRIORITY_ORDER: Priority[] = [0, 1, 2, 3, 4];
